/* 
*  Created by SGiri 06/29/2018
*/

import { NgModule } from "@angular/core";
import {
    MatTabsModule,
    MatButtonModule,
    MatSelectModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatIconModule, MatDialogModule,
    MatDividerModule,
    MatAutocompleteModule,
    MatInputModule,
    MatNativeDateModule,
    MatDatepickerModule
} from "@angular/material";

@NgModule({
    exports: [
        MatTabsModule,
        MatButtonModule,
        MatInputModule,
        MatSelectModule,
        MatCheckboxModule,
        MatTooltipModule,
        MatIconModule,
        MatDialogModule,
        MatDividerModule,
        MatAutocompleteModule,
        MatNativeDateModule, 
        MatDatepickerModule
    ]
})
export class MaterialModule {
}



// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/material/material.module.ts